var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTownHall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.36,
    height: 17.39,
    viewBox: "0 0 17.36 17.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_32966",
    "data-name": "Tracciato 32966",
    d: "M17.36,14.775V17.39H0V14.771H.537V6.614H0V6.409c0-1.223,0-2.445,0-3.668a.225.225,0,0,1,.2-.263Q4.13,1.336,8.058.182C8.245.127,8.429.061,8.614,0H8.75a.991.991,0,0,0,.133.061l5.723,1.673q1.378.4,2.754.813V6.623h-.532v8.152ZM1.026,3.994h15.31V3.305l-.151-.047Q12.507,2.182,8.829,1.109a.553.553,0,0,0-.293,0q-3.12.9-6.236,1.819c-.426.124-.851.251-1.274.376ZM3.647,14.767H4.932V6.627H3.647Zm8.787-.005h1.287V6.628H12.434ZM9.319,6.631H8.045v8.14H9.319Zm7.019-1.593H1.032v.549H16.339Zm0,10.769H1.029v.555h15.3ZM2.606,6.631H1.573v8.138H2.606Zm3.368,8.135H7V6.627H5.975Zm5.417-8.132H10.358v8.133h1.033Zm4.4,0H14.759V14.77H15.79Z",
    transform: "translate(0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTownHall);
export default __webpack_public_path__ + "static/media/town-hall.ec6e01f4be155ca53fbe5a9ab73476ef.svg";
export { ForwardRef as ReactComponent };